import LoadingOverlay from 'components/common/LoadingOverlay';
import { Role } from 'graphql/generated/graphql';
import requireValue from 'utils/requireValue';
import AppRouter from './AppRouter';
import AuthRouter from './AuthRouter';
import useUser from '../hooks/useUser';

const RootRouter = () => {
  const [user, loading] = useUser();

  if (loading && !user) {
    return <LoadingOverlay />;
  }

  // Roles that are null (the schema allows it) throw, as they did.
  if (user && !requireValue(user.roles, 'includes').includes(Role.admin)) {
    return <AuthRouter />;
  }

  return <>{user ? <AppRouter /> : <AuthRouter />}</>;
};

export default RootRouter;
